var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectionalLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0060837 16.9733C0.00491833 16.4069 0.212837 15.8579 0.593749 15.4218L13.3691 0.875794C13.8028 0.380706 14.426 0.0693629 15.1016 0.0102584C15.7773 -0.048846 16.45 0.149129 16.9718 0.560631C17.4935 0.972133 17.8217 1.56345 17.884 2.20451C17.9463 2.84557 17.7376 3.48385 17.3039 3.97893L5.8572 16.9733L16.8951 29.9677C17.1073 30.2157 17.2658 30.501 17.3615 30.8073C17.4571 31.1136 17.488 31.4348 17.4524 31.7525C17.4168 32.0701 17.3154 32.378 17.1539 32.6583C16.9925 32.9387 16.7743 33.186 16.5118 33.386C16.2491 33.6081 15.9409 33.7762 15.6065 33.8799C15.2721 33.9837 14.9188 34.0208 14.5686 33.9889C14.2183 33.9571 13.8789 33.8569 13.5713 33.6948C13.2638 33.5326 12.9949 33.312 12.7814 33.0466L0.440446 18.5007C0.119744 18.052 -0.0331905 17.5142 0.0060837 16.9733Z",
    fill: "current-color"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionalLeft);
export default __webpack_public_path__ + "static/media/directional-left.1eb76c8f.svg";
export { ForwardRef as ReactComponent };